<template>
  <el-dialog
    title="预览"
    class="cus-dialog-container"
    :visible.sync="dialogFormVisible"
    fullscreen
  >
    <el-card v-if="hasBasic" class="preview-card">
      <div slot="header" class="clearfix">
        <span>属性设置</span>
      </div>
      <el-form :label-width="labelWidth">
        <el-form-item label="表单名称" required>
          <el-input v-model="previewData.basicSetting.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="表单图标" required>
          <img
            :src="previewData.basicSetting.icon"
            style="width: 28px;height: 28px;vertical-align: middle;"
          />
        </el-form-item>
        <el-form-item label="表单说明">
          <el-input
            v-model="previewData.basicSetting.description"
            type="textarea"
            :maxlength="100"
            show-word-limit
            :autosize="{ minRows: 4, maxRows: 4 }"
            :style="{ width: '100%' }"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card
      v-if="
        dialogFormVisible &&
          hasForm &&
          previewData.formData &&
          previewData.formData.list &&
          previewData.formData.list.length > 0
      "
      class="preview-card"
    >
      <div slot="header" class="clearfix">
        <span>内容设置</span>
      </div>
      <fm-generate-form
        ref="generateForm"
        :data="previewData.formData"
      ></fm-generate-form>
    </el-card>
    <el-card v-if="hasProcess && processData.length > 0" class="preview-card">
      <div slot="header" class="clearfix">
        <span>审批流程</span>
      </div>

      <el-form :label-width="labelWidth">
        <template v-for="(item, i) in processData">
          <el-form-item :key="i" :label="item.title" required>
            <div
              class="process-check"
              :class="{
                'is-approver': item.nodeType === 1
              }"
              @click="viewAuditStyle(item)"
            >
              <p class="process-check-label">
                <span
                  class="process-check-label-title"
                  v-html="item.content"
                ></span>
                <template v-if="item.nodeType === 1">
                  <el-tag
                    v-if="item.auditStyleType === 1"
                    size="mini"
                    type="info"
                    >默认审批</el-tag
                  >
                  <el-tag v-if="item.auditStyleType === 2" size="mini"
                    >自定义审批</el-tag
                  >
                </template>
              </p>
              <el-radio label="" class="process-radio"></el-radio>
            </div>
          </el-form-item>
        </template>
      </el-form>
    </el-card>
    <el-dialog
      title="审批样式"
      append-to-body
      :visible.sync="approverStyleVisible"
    >
      <el-form v-if="!formDataTemplate" label-width="100px">
        <el-form-item label="审批结果" required>
          <el-row>
            <el-col :span="20">
              <el-radio-group :value="1" disabled>
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </el-col>
            <el-col :span="4"></el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          label="审批意见"
          :required="currentApprover.requireAuditOpinion === 1"
        >
          <el-input
            type="textarea"
            :rows="4"
            :maxlength="200"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="附件"
          :required="currentApprover.requireAttachment === 1"
        >
          <el-button type="primary" size="small" disabled>
            点击上传
          </el-button>
        </el-form-item>
      </el-form>
      <fm-generate-form
        v-else
        ref="generateFormRef"
        :data="formDataTemplate"
        :edit="false"
      ></fm-generate-form>
    </el-dialog>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogFormVisible = false"
        >关 闭</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { initProcessData } from "@/utils";

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    previewData: {
      type: [Object, String]
    },
    workConfig: {
      type: Object,
      default: () => {}
    },
    // 显示属性设置
    hasBasic: {
      type: Boolean,
      default: true
    },
    // 显示内容设置
    hasForm: {
      type: Boolean,
      default: true
    },
    // 显示流程设置
    hasProcess: {
      type: Boolean,
      default: true
    }
  },
  data() {
    //这里存放数据
    return {
      dialogFormVisible: false,
      labelWidth: "150px",
      processData: [],
      currentApprover: {},
      approverStyleVisible: false,
      formDataTemplate: ""
    };
  },
  computed: {
    formParams() {
      return {
        token: this.workConfig.token,
        projectType: this.workConfig.projectType,
        projectId: this.workConfig.projectId
      };
    }
  },
  //监控data中的数据变化
  watch: {
    show(val) {
      this.dialogFormVisible = val;
    },
    dialogFormVisible(val) {
      this.$emit("update:show", val);
    },
    previewData(val) {
      console.log("预览数据", this.previewData, this.$refs.generateForm);
      if (this.$refs.generateForm) {
        this.$refs.generateForm.setData(this.previewData.formData);
      }
      this.initProcessData();
    }
  },
  //方法集合
  methods: {
    // 处理审批数据
    initProcessData() {
      let processData = initProcessData(this.previewData.processData);
      console.log("处理审批数据", processData, this.workConfig);
      this.processData = processData;
    },
    // 查看审批样式
    viewAuditStyle(item) {
      console.log("查看审批样式", item);
      if (item.nodeType !== 1 || item.auditStyleType === 3) {
        return;
      }
      if (item.auditStyleId) {
        this.getDetailsAuditStyle(item.auditStyleId);
      } else {
        this.formDataTemplate = "";
      }
      this.currentApprover = Object.assign({}, item);
      this.approverStyleVisible = true;
    },
    // 审批样式详情
    async getDetailsAuditStyle(id) {
      let result = await this.$axios.get(
        this.workConfig.configApi.getDetailsAuditStyle + id,
        this.formParams
      );
      let datas = result.data;
      let template = JSON.parse(datas.template);
      this.formDataTemplate = template;
    }
  }
};
</script>
<style lang="less" scoped>
.preview-card {
  margin-bottom: 15px;
}
.process-check {
  width: 50%;
  display: inline-flex;
  align-items: center;
  .process-check-label {
    flex: 1;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    .process-check-label-title {
      margin-right: 10px;
    }
  }
  .process-radio {
    display: none;
  }
  &.is-approver {
    cursor: pointer;
    .process-radio {
      display: block;
    }
  }
}
</style>
